import createHistory from "history/createBrowserHistory";
import config from "appConfig";
import { stringifyURI } from "./services/utils";
import { getAuthDomain } from "./services/domain";
import { ModuleName, ModuleNameHr, PageRoute, QueryParam } from "./models";
import { doesCategoryExist } from "./routes/LanguageMapper";
import ReactGA from "react-ga4";

const history = createHistory({ basename: config.baseFolder });

export const redirectFromForbiddenAd = (module: string, category: string) => {
  if (module == ModuleName.realEstate) {
    history.replace(`/${module}${stringifyURI({ category }, QueryParam.searchQuery)}`);
  } else {
    history.replace(`/${module}/${category}`);
  }
};

export const navigateTo404Page = async (response: Response | Object = {}) => {
  const url = history.location.pathname;
  const slash = url.startsWith("/") ? "" : "/";

  let adNotFoundData = {};

  if (response instanceof Response) {
    try {
      adNotFoundData = { ...await response.json() };
    } catch (e) {
      adNotFoundData = {};
    }
  }

  // If no data from response, try to extract module and category from URL
  // URL structure: /{module}/{category}/oglas/{smartLink}/{id}
  // Only apply for ad detail URLs with valid module
  if (Object.keys(adNotFoundData).length === 0 && url.includes(PageRoute.details)) {
    const parts = url.split("/").filter(Boolean);
    if (parts.length >= 2) {
      const module = parts[0];
      const category = parts[1];
      const validModules = Object.values(ModuleNameHr);

      if (validModules.includes(module) && doesCategoryExist(category, module)) {
        adNotFoundData = {
          module,
          category,
          redirectUrl: `${module}/${category}`
        };
      }
    }
  }

  history.replace({
    pathname: "/not-found",
    state: { adNotFoundData }
  });

  window.history.replaceState(
    null,
    window.document.title,
    `${config.publicUrl}${slash}${url}`
  );
};

export const getRelativeReturnUrl = (returnUrl?: string) => {
  const target = new URL(returnUrl || window.location.href, window.location.origin);

  if (target.origin !== window.location.origin || target.pathname.includes(PageRoute.verifyEmail)) {
    return config.baseFolder || "/";
  }

  return target.pathname + target.search + target.hash;
};

export const navigateToLogin = (returnUrl?: string) => {
  const url = getRelativeReturnUrl(returnUrl);

  ReactGA.event({
    category: "Prijava korisnika",
    action: "Click",
    label: "Klik na “prijavi se”"
  });

  window.location.href =
    `${window.location.protocol}//${getAuthDomain()}${config.baseFolder}${config.authUrlPrefix}?returnUrl=${encodeURIComponent(url)}`;
};

export default history;



// WEBPACK FOOTER //
// ./src/history.ts